import { createSlice } from '@reduxjs/toolkit'

import {
    TestMemberShipLists,
    TestMemberShipListOld,
    TestSubMemberMemberList,
    TestPlanListByMember
} from '../MembershipList/thunk'
import _ from 'lodash'
import moment from 'moment'
import { getDateWithFormat } from 'src/helpers/dateTimeHelper'

export const initialState = {
    loading: true,
    list: [],
    subMemberMembershipData: {
        list: [],
        loading: true
    },
    planListByMember: {
        list: [],
        loading: true
    }
}

const TestMemberShipList = createSlice({
    name: 'TestMembership/List',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(TestMemberShipLists.pending, (state) => {
            state.loading = true
        })
        builder.addCase(TestMemberShipLists.fulfilled, (state, action) => {
            const { payload } = action
            state.list = payload || []
            state.loading = false
        })
        builder.addCase(TestMemberShipLists.rejected, (state) => {
            state.loading = false
        })
        builder.addCase(TestMemberShipListOld.pending, (state) => {
            state.loading = true
        })
        builder.addCase(TestMemberShipListOld.fulfilled, (state, action) => {
            const { payload } = action
            state.list = payload || []
            state.loading = false
        })
        builder.addCase(TestMemberShipListOld.rejected, (state) => {
            state.loading = false
        })
        builder.addCase(TestSubMemberMemberList.pending, (state) => {
            state.subMemberMembershipData.list = []
            state.subMemberMembershipData.loading = true
        })
        builder.addCase(TestSubMemberMemberList.fulfilled, (state, action) => {
            const { payload } = action
            state.subMemberMembershipData.list = payload || []
            state.subMemberMembershipData.loading = false
        })
        builder.addCase(TestSubMemberMemberList.rejected, (state) => {
            state.subMemberMembershipData.list = []
            state.subMemberMembershipData.loading = false
        })
        builder.addCase(TestPlanListByMember.pending, (state) => {
            state.planListByMember.list = []
            state.planListByMember.loading = true
        })
        builder.addCase(TestPlanListByMember.fulfilled, (state, action) => {
            const { payload } = action
            state.planListByMember.list = _.map(payload || [], (o) => {
                return {
                    ...o,
                    isPlanExpired: o?.new_expires_on
                        ? moment(moment(getDateWithFormat(o?.new_expires_on)).format('YYYY-MM-DD')).isBefore(
                            moment().format('YYYY-MM-DD')
                        )
                        : false
                }
            })
            state.planListByMember.loading = false
        })
        builder.addCase(TestPlanListByMember.rejected, (state) => {
            state.planListByMember.list = []
            state.planListByMember.loading = false
        })
    }
})

export default TestMemberShipList.reducer
